// basesize, 375宽屏幕下1bs等于1px
// const bs = window.innerWidth / 375

const texts = {
  // guide: {
  //   text: '向上滑动，找回童年',
  //   position: { x: 0.5, y: 0.5 },
  //   anchor: 'center',
  //   options: {
  //     fontFamily: 'Arial',
  //     fontSize: bs * 18,
  //     fill: 0xfb833f,
  //     align: 'center'
  //   }
  // }
}

export default texts



// WEBPACK FOOTER //
// ./src/assets/texts.js